import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

/** Builds /terms URL with safe return path for "Back" on the terms page */
export function buildTermsUrl(returnPath) {
  const prefix = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const path = `${prefix}/terms`.replace(/([^:]\/)\/+/g, "$1") || "/terms";
  if (!returnPath || typeof returnPath !== "string") {
    return path;
  }
  const safe =
    returnPath.startsWith("/") && !returnPath.startsWith("//")
      ? returnPath
      : "/";
  return `${path}?return=${encodeURIComponent(safe)}`;
}

export const TermsLink = ({ style = {} }) => {
  const { t } = useTranslation("translation");
  const location = useLocation();
  const current = `${location.pathname}${location.search || ""}`;
  const href = buildTermsUrl(current);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#666",
        fontSize: style.fontSize || "14px",
        textDecoration: "none",
        ...style,
      }}
    >
      {t("terms-page-link")}
    </a>
  );
};
